import AutocompleteZ from '@/components/forms/AutocompleteZ'
import SimpleTableList from '@/components/forms/SimpleTableList'
import TreeView from '@/components/treeview/TreeView'
import ObraRepository from '@/shared/http/repositories/business/obra'
import COPModeloObraItemPrRepository from '@/shared/http/repositories/pci/copmodeloobraitempr'
import COPOficialWorkModelRepository from '@/shared/http/repositories/pci/copoficialworkmodel'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import PCILayoutContaRepository from '@/shared/http/repositories/pci/pcilayoutconta'
import PDRRepository from '@/shared/http/repositories/pci/pdr'
import PDRAvaliacaoRepository from '@/shared/http/repositories/pci/pdrobraavaliacao'
import TecAnalysisRepository from '@/shared/http/repositories/pci/tecanalysis'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles'
import PermissionMixin from '@/store/module/permission/mixin'
import FileSelection from '@/views/private/operational/documents/components/folderselection/fileselection.vue'
import { createPopper } from '@popperjs/core'
import { AgGridVue } from 'ag-grid-vue'
import { cloneDeep, debounce, isEqual } from 'lodash'
import moment from 'moment'
import BooleanFloatingFilter from './components/BooleanFloatingFilter'
import FilesButton from './components/FilesButton.vue'
import LayoutSidebar from './components/LayoutSidebar.vue'
import Annex from './components/annex/annex.vue'
import Bills from './components/bills/bills.vue'
import Cancellation from './components/cancellation/cancellation.vue'
import Considerations from './components/considerations/considerations.vue'
import ConstructionAddress from './components/construction/constructionAddress.vue'
import ConstructionCandidate from './components/construction/constructionCandidate.vue'
import ConstructionTeam from './components/construction/constructionTeam.vue'
import Cop from './components/cop/cop.vue'
import CopSmartpci from './components/cop/cop-smartpci.vue'
import PurchaseOrderClient from './components/po/po.vue'
import PurchaseOrder from './components/purchaseorder/purchaseorder.vue'
import Resume from './components/resume/resume.vue'
import Stoppage from './components/stoppage/stoppage.vue'
import TecAnalysis from './components/tecanalysis/tecanalysis.vue'
import tecAnalysisTypes from './components/tecanalysis/tecanalysistypes'
import TecAnalysisNa from './components/tecanalysisna/tecanalysisna.vue'
import gridMixin from './mixins/gridMixin'
import ReportJuridicoContrato from './reports/ReportJuridicoContrato.vue'
import GedFolderRepository from '@/shared/http/repositories/business/gedfolder'

export default {
  name: 'PCI',
  components: {
    AgGridVue,
    SimpleTableList,
    TreeView,
    BooleanFloatingFilter,
    FilesButton,
    LayoutSidebar,
    AutocompleteZ,
    ConstructionAddress,
    ConstructionTeam,
    ConstructionCandidate,
    TecAnalysis,
    TecAnalysisNa,
    Stoppage,
    Cancellation,
    PurchaseOrderClient,
    Bills,
    PurchaseOrder,
    Cop,
    CopSmartpci,
    Considerations,
    Annex,
    Resume,
    FileSelection,
    ReportJuridicoContrato
  },
  mixins: [ActionsForm, gridMixin, PermissionMixin],
  computed: {
    selectedCount () {
      return this.objList.filter(f => f.checked).length
    },
    alertsStyle () {
      if (this.alertFilter) {
        return this.alertFilter.class
      } else {
        return {
          'far fa-bell': this.alerts.length === 0,
          'fas fa-bell': this.alerts.length > 0
        }
      }
    },
    alertGroups () {
      const groups = [
        {
          id: null,
          class: 'fas fa-filter',
          name: 'Sem Grupo'
        }
      ]

      this.alerts.map(alert => {
        if (alert.pciModeloItemValid && alert.pciModeloItemValid.alertaGrupo && groups.findIndex(a => a.id === alert.pciModeloItemValid.alertaGrupoID) === -1) {
          groups.push({
            id: alert.pciModeloItemValid.alertaGrupoID,
            class: alert.pciModeloItemValid.alertaGrupo.icone,
            name: alert.pciModeloItemValid.alertaGrupo.nome
          })
        }
      })

      return groups
    }
  },
  data () {
    return {
      advSearch: {
        lastClickedColumn: null,
        lastSearchedWord: '',
        originalData: null
      },
      searchField: '',
      objList: [],
      sendingFiles: [],
      pciId: [],
      // Entrada do ZSistemas (authsso): planilha restrita a uma obra. null = planilha inteira.
      obraIdFiltro: null,
      obraRefFiltro: '',
      rowData: [],
      loadingAlerts: false,
      originalColState: [],
      pciCountRowData: [{}],
      quotes: {},
      roles: Roles,
      showAnnex: false,
      showArquivos: false,
      showStoppage: false,
      showCancellation: false,
      showConsiderations: false,
      showConstructionAddress: false,
      showConstructionTeam: false,
      showConstructionCandidate: false,
      showZdocs: false,
      showFolderZdocs: false,
      showItemAlteracaoLog: false,
      showPdrSetNAReason: false,
      showPdrLog: false,
      showPdrTeam: false,
      // chamado 20121: confirmacao antes de abrir os formularios quando o COP da obra
      // ainda tem pendencia de aprovacao (depois de liberado o COP nao muda mais).
      showCopPendenciasConfirm: false,
      copPendenciasRow: null,
      copPendencias: { aguardando: 0, aprovadoSupervisor: 0, aprovadoCoordenador: 0, total: 0 },
      showZeroPDR: false,
      showRejectPDR: false,
      showCopOf: false,
      showCopSmart: false,
      copReadOnly: false,
      showTecAnalysis: false,
      showTecAnalysisNa: false,
      showPo: false,
      showBills: false,
      showPurchaseOrder: false,
      showMiniatures: false,
      showResume: false,
      showAfterGeneratePDR: false,
      showAuthorizePDR: false,
      showQuotes: false,
      gridPCI: null,
      gridColumnPCI: null,
      selectedObraID: null,
      selectedFolderId: null,
      rowFiltered: null,
      rowSetNA: null,
      filterList: [],
      filterSelected: null,
      isDragging: false,
      isUndeleting: false,
      xlsFile: null,
      montagemPdrList: [],
      rowSelectedPdr: null,
      rejectReason: null,
      zeroReason: null,
      pciObraIdPdrTeam: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      countColumnDefs: null,
      acceptedFiles: '',
      teamColumnDefs: null,
      teamGridOptions: {},
      headersTotalize: {},
      logPdr: null,
      logItemPci: null,
      showGrid: false,
      updatingLayout: true,
      alerts: [],
      alertsFiltered: [],
      alertFilter: null,
      alertUnfilter: null,
      showAlerts: false,
      pdrNaReason: '',
      pageLimit: 99999,
      pciDataGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20,
        suppressHorizontalScroll: true,
        alignedGrids: [],
        rowClassRules: {
          rowOdd: (params) => {
            return (params.node.rowIndex || 0) % 2 !== 0
          }
        },
        defaultExcelExportParams: {
          processRowGroupCallback (params) {
            const { node } = params
            let qt = 0

            const childrenCount = n => {
              if (n.childrenAfterFilter) {
                n.childrenAfterFilter.forEach(c => childrenCount(c))
              } else {
                qt++
              }
            }

            if (node.childrenAfterFilter) {
              node.childrenAfterFilter.forEach(c => childrenCount(c))
            }
            if (!node.footer) {
              return `${node.key} (${qt})`
            }
          }
        }
      },
      pciCountGridOptions: {
        rowHeight: 20,
        alignedGrids: [],
        defaultColDef: {
          editable: false,
          sortable: false,
          resizable: false,
          filter: false,
          cellStyle: {
            'background-color': '#00814312',
            'font-weight': 'bold'
          }
        }
      },
      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            minWidth: 225,
            width: 300,
            maxWidth: 500,
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true
            }
          },
          {
            id: 'filters',
            labelDefault: 'Filters',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
            minWidth: 300,
            width: 400,
            maxWidth: 500
          },
          {
            id: 'layout',
            labelDefault: 'Layout',
            labelKey: 'layout',
            iconKey: 'menu',
            toolPanel: 'LayoutSidebar',
            minWidth: 300,
            maxWidth: 500,
            width: 400
          }
        ],
        position: 'right'
      },
      countColumnTypes: {
        smallColumn: {
          minWidth: 30
        },
        numberColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: 'ag-right-aligned-cell',
          minWidth: 100,
          cellRendererSelector: (params) => {
            let value = params.value
            if (typeof params.value === 'string') {
              value = Number.parseFloat(params.value.replaceAll(',', '.'))
            }
            try {
              value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : null
            } catch (error) {
              value = null
              console.log(error)
            }
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: value
              }
            }
          }
        },
        integerColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: 'ag-right-aligned-cell',
          minWidth: 100
        },
        memoColumn: {
          maxWidth: 500,
          minWidth: 200
        },
        textColumn: {
          minWidth: 100
        },
        booleanColumn: {
          minWidth: 100
        },
        dateColumn: {
          cellClass: 'dateType',
          minWidth: 100
        },
        valuesColumn: {
          minWidth: 100
        },
        attachmentColumn: {
          minWidth: 100
        },
        pdrStatusColumn: {
          minWidth: 100
        },
        pdrDepartamentoStatusColumn: {
          minWidth: 100
        },
        atStatusColumn: {
          minWidth: 100
        },
        position: 'left'
      },
      afterGeneratePDRModal: {
        startDate: '',
        endDate: '',
        observation: '',
        lateDays: '',
        isLate: false,
        workID: '',
        isReadOnly: false,
        releaseDate: '',
        title: '',
        confirmButton: '',
        daysToLate: 45
      },
      authorizePDRModal: {
        observation: ''
      },
      constructionAddressValidation: {
        cidade: true,
        estado: true
      },
      openReport: false,
      dataReport: []
    }
  },
  methods: {
    onLoad () {},
    changeCurrentFolder (folder) {
      loading.push()
      PCIRepository.SendFolderObra(this.selectedObraID, folder)
        .then(response => {
          this.loadGridRowValues()
        })
        .catch(err => {
          this.onException(err)
        }).finally(() => loading.close())
    },
    tipoServico (tipo) {
      switch (tipo) {
        case 1: {
          return 'INFRA'
        }
        case 2: {
          return 'INSTALAÇÃO'
        }
        case 3: {
          return 'OUTROS'
        }
        case 4: {
          return 'PROJETO'
        }
        default: {
          return 'NÃO IDENTIFICADO'
        }
      }
    },
    onGridPCIReady (params) {
      this.gridPCI = params.api
      this.gridColumnPCI = params.columnApi
    },
    onSearchFieldChanged () {
      this.gridPCI.setQuickFilter(
        this.searchField
      )
    },
    selectZdocsFolder (obraID) {
      this.showFolderZdocs = true
      this.selectedObraID = obraID
      this.selectedFolderId = null
      this.$nextTick(() => {
        this.$refs.zDocsFolder.openModalGed()
      })
    },
    showZdocsFolder (params) {
      GedFolderRepository.Get(params.gedPastaId)
        .then(response => {
          const folder = response.data.data
          if (!folder || folder.status === 0) {
            toast.warning(this.$lang.PCI.Documents.WarningDeletedFoldersLinked)
            return
          }
          if (params.gedPastaId) {
            this.showZdocs = true
            this.selectedObraID = params.obraId
            this.selectedFolderId = params.gedPastaId
            this.$nextTick(() => {
              this.$refs.zDocs.openModalGed()
            })
          } else {
            toast.warning(this.$lang.PCI.Documents.WarningNoFoldersLinked)
          }
        }).catch(err => {
          this.onException(err)
        })
    },
    printPdf (obraid) {
      console.log(obraid)
      loading.push()
      PDRAvaliacaoRepository.PrintFormularioAprovacaoPorObra(obraid)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
            this.onLoad()
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    viewPciItemLog (row) {
      loading.push()
      WorkPCIRepository.GetLogItemModelo(row.node.data.id, row.column.colId)
        .then(response => {
          this.logItemPci = response.data.data
          this.showItemAlteracaoLog = true
        })
        .finally(() => loading.close())
    },
    onDragOver (event) {
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (!this.isUndeleting) {
        event.dataTransfer.dropEffect = 'copy'
        event.dataTransfer.effectAllowed = 'copy'
      }
    },
    onDragEnter (event) {
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (!this.isUndeleting) {
        event.dataTransfer.dropEffect = 'copy'
        event.dataTransfer.effectAllowed = 'copy'
        this.isDragging = true
      }
    },
    onDragLeave (event) {
      event.preventDefault()
      event.stopPropagation()

      this.isDragging = false
    },
    viewAddress (row) {
      this.showConstructionAddress = true
      this.$nextTick(() => {
        this.$refs.address.show(row.node.data)
      })
    },
    viewTeam () {
      const rowIndex = this.pciDataGridOptions.api.getCellRanges()[0].startRow.rowIndex
      const rowNode = this.pciDataGridOptions.api.rowModel.getRow(rowIndex)
      this.showConstructionTeam = true
      this.$nextTick(() => {
        this.$refs.team.show(rowNode.data)
      })
    },
    viewBatchTeam () {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = []
      ranges.forEach(rg => {
        for (let i = rg.startRow.rowIndex; i <= rg.endRow.rowIndex; i++) {
          const rowData = this.pciDataGridOptions.api.rowModel.getRow(i).data
          data.push(rowData)
        }
      })
      this.showConstructionTeam = true
      this.$nextTick(() => {
        this.$refs['team'].showBatch(data)
      })
    },
    viewCandidates (row) {
      this.showConstructionCandidate = true
      this.$nextTick(() => {
        this.$refs.candidate.show(row.node.data)
      })
    },
    viewResume (row) {
      this.showResume = true
      this.$nextTick(() => {
        this.$refs.resume.show([row.node.data.pciId])
      })
    },
    onUpdateAddress (data) {
      if (!data.estado) {
        this.constructionAddressValidation.estado = false
        return
      }
      if (!data.cidade) {
        this.constructionAddressValidation.cidade = false
        return
      }

      loading.push()
      const rowIndex = this.gridApi.getFocusedCell().rowIndex
      const row = this.gridApi.rowModel.getRow(rowIndex)
      ObraRepository.UpdateAddress(row.data.id, data)
        .then(() => {
          row.setDataValue('endereco', data.endereco, 'blockEdit')
          row.setDataValue('numero', data.numero, 'blockEdit')
          row.setDataValue('bairro', data.bairro, 'blockEdit')
          row.setDataValue('cidade', data.cidade, 'blockEdit')
          row.setDataValue('uf', data.estado, 'blockEdit')
          row.setDataValue('cep', data.cep, 'blockEdit')
          row.setDataValue('latitude', data.latitude, 'blockEdit')
          row.setDataValue('longitude', data.longitude, 'blockEdit')
          row.setDataValue('altitude', data.altitude, 'blockEdit')
          row.setDataValue('tipo', data.tipo, 'blockEdit')
          // row.setDataValue('equipamento', data.equipamento, 'blockEdit')
          row.setDataValue('idDetentora', data.idDetentora, 'blockEdit')
          row.setDataValue('detentora', data.detentora, 'blockEdit')

          this.showConstructionAddress = false
          this.restoreFocus()
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => {
          loading.close()
          this.calculateTotals()
        })
    },
    onUpdateTeam (data) {
      if (!window.work2Automatization[data.obraID]) {
        return PCIRepository.GetPCIWork(data.obraID)
          .then(response => {
            if (response.data.code > 0) {
              response.data.data[0].Data[0].item = data.item
              this.gridApi.applyTransactionAsync({ update: [...response.data.data[0].Data] })
            }
          })
      }
    },
    onUpdateCandidates (data) {
      this.showConstructionCandidate = false
      this.onLoadGridValues()
    },
    onHideCop () {
      this.showCopOf = false
      this.reprocessLine()
    },
    onHideCopSmart () {
      this.showCopSmart = false
      this.reprocessLine()
    },
    viewPdrLog (row) {
      loading.push()
      PDRAvaliacaoRepository.GetLog(row.node.data.id)
        .then(response => {
          this.logPdr = []
          response.data.data.forEach(i => {
            this.logPdr.push({
              id: i.id,
              dataAcaoFormatada: i.dataAcaoFormatada,
              descricao: i.descricao,
              nomeContaAcao: i.nomeContaAcao
            })
          })
          this.showPdrLog = true
        })
        .finally(() => loading.close())
    },
    beforeEdit (params) {
      // Prevent edit on #NA# or #NREF#
      if (params.value === '#NA#' || params.value === '#NREF#') {
        this.gridApi.stopEditing()
      } else {
        return params
      }
    },
    calculateTotals () {
      const rowDataCount = [[], []]
      const columns = this.pciCountGridOptions.columnApi.getColumns()
      columns.forEach(col => {
        rowDataCount[0][col.colDef.field] = 0
        rowDataCount[1][col.colDef.field] = 0.00
      })

      this.gridApi.rowModel.forEachNodeAfterFilter(row => {
        if (!row.group && row.data) {
          Object.keys(row.data).forEach(field => {
            if (row.data[field] && row.data[field] !== '#NA#' && row.data[field] !== '#NREF#') {
              const totalize = this.headersTotalize[field]
              rowDataCount[0][field] = rowDataCount[0][field] || 0
              rowDataCount[0][field] += 1
              if (totalize === 'sum') {
                if (typeof row.data[field] === 'number') {
                  rowDataCount[1][field] += row.data[field]
                } else {
                  const value = parseFloat(row.data[field].replaceAll(this.moneyFormat.thowsands, '').replaceAll(this.moneyFormat.decimal, '.'))
                  rowDataCount[1][field] += (value || 0)
                }
              }
            }
          })
        }
      })
      this.pciCountRowData = rowDataCount
      // this.$nextTick(() => {
      // })
    },
    loadGridRowValues () {
      const ranges = this.gridApi.getCellRanges()
      const rows = {}
      if (ranges) {
        ranges.forEach(r => {
          for (var i = r.startRow.rowIndex; i <= r.endRow.rowIndex; i++) {
            rows[i] = 0
          }
        })
        Object.keys(rows).forEach(r => {
          const node = this.gridApi.rowModel.getRow(r)
          if (!window.work2Automatization[node.data.obraId]) {
            return PCIRepository.GetPCIWork(node.data.obraId)
              .then(response => {
                if (response.data.code > 0 && response.data.data.length) {
                  response.data.data[0].Data[0].item = node.data.item
                  this.gridApi.applyTransactionAsync({ update: [...response.data.data[0].Data] })
                }
              })
          }
        })
      }
    },
    loadGridValues (data) {
      this.gridApi = this.pciDataGridOptions.api
      this.columnApi = this.pciDataGridOptions.columnApi

      // Verifies if response has data
      if (data.Data && data.Data.length) {
        let contracts = data.Data.reduce((prev, curr) => {
          const reg = curr.referenciaContrato.substring(0, 3)
          const ctr = curr.referenciaContrato.substring(4)
          if (!prev[ctr]) prev[ctr] = {}
          prev[ctr][reg] = null
          return prev
        }, {})

        var title = ''
        for (const [key, value] of Object.entries(contracts)) {
          title = title + '['
          const keys = Object.keys(value)
          keys.forEach((kv, idx) => {
            if (idx <= 3) {
              if (idx < 3) {
                title = title + kv
                if (idx < 2 && idx < keys.length - 1) {
                  title = title + '/'
                }
              } else if (idx === 3) {
                title = title + '...'
              }
            }
          })
          title = title + '-' + key + '] '
        }
        document.querySelector('title').innerText = title

        if (this.gridApi) {
          const filter = this.gridApi.getFilterModel()
          this.gridApi.setRowData([])
          this.rowData = data.Data
          this.gridApi.applyTransaction({ add: [...data.Data] })
          if (filter) this.gridApi.setFilterModel(filter)
        } else {
          this.rowData.push(...data.Data)
        }

        this.calculateTotals()
      } else this.pciDataGridOptions.api.hideOverlay()

      this.loadingAlerts = true
      PCIRepository.GetAlerts(this.pciId)
        .then(response => {
          if (response.data.code > 0) {
            this.alerts = this.alertasDoFiltro(response.data.data)
            this.onFilterAlertRows(this.alertFilter)
            this.gridPCI.refreshCells({force: true})
          }
        })
        .finally(() => {
          this.loadingAlerts = false
        })
        .then(() => {
          this.loadQuotes()
        })
    },
    // Com a planilha restrita a uma obra, o painel de alertas so conta os dessa obra -- senao mostraria
    // pendencias de obras que nao estao na grid.
    alertasDoFiltro (alertas) {
      if (!this.obraIdFiltro || !Array.isArray(alertas)) return alertas
      const obra = this.obraIdFiltro.toLowerCase()
      return alertas.filter(a => String(a.obraID).toLowerCase() === obra)
    },
    async onLoadGridValues (getHeaders) {
      this.updatingLayout = true
      let data = { Data: [] }
      let headers
      loading.push()

      // Dispara as duas promessas em paralelo
      const headerPromise = PCIRepository.GetPCIHeader(this.pciId)
      const worksConfig = this.obraIdFiltro ? { params: { obraID: this.obraIdFiltro } } : {}
      const worksPromises = this.pciId.map(id => PCIRepository.GetPCIWorks([id], worksConfig))

      // Aguarda todas de uma vez
      const [responseHeader, ...responses] = await Promise.all([
        headerPromise,
        ...worksPromises
      ])

      if (getHeaders) {
        this.columnDefs = headers = responseHeader.data.data[0].Headers
        const getFieldTotalize = headerNode => {
          if (headerNode.children) {
            headerNode.children.forEach(h => getFieldTotalize(h))
          } else {
            this.headersTotalize[headerNode.field] = headerNode.TotalizarColuna ? 'sum' : 'count'
            if (headerNode.cellStyle) {
              // eslint-disable-next-line no-eval
              headerNode.cellStyle = eval(headerNode.cellStyle)
              headerNode.filterParams = {
                cellRenderer: 'FilterCollorCellRenderer',
                cellRendererParams: { cellStyle: headerNode.cellStyle }
              }
            }
            if (headerNode.field === 'referencia' || headerNode.field === 'idSite') {
              headerNode.cellRendererParams = {
                search: () => this.advSearch.lastSearchedWord, nref: true
              }
            } else {
              headerNode.cellRendererParams = {
                nref: true
              }
            }
          }
        }

        headers.forEach(h => getFieldTotalize(h))

        const removeCellStyle = headerNode => {
          if (headerNode.cellStyle) {
            delete headerNode['cellStyle']
          }
          if (headerNode.children) {
            headerNode.children.forEach(h => removeCellStyle(h))
          }
          headerNode.cellClass = 'ag-right-aligned-cell'
          headerNode.minWidth = 30
          headerNode.type = 'textColumn'
          headerNode.cellRenderer = (params) => {
            let value = params.value
            if (params.node.rowIndex === 0) {
              value = value && value.replaceAll ? Number.parseInt(value) : value
              try {
                value = value ? value.toLocaleString('pt-BR') : null
              } catch (error) {
                value = null
                console.log(error)
              }
            } else {
              if (typeof params.value === 'string') {
                value = Number.parseFloat(params.value.replaceAll(',', '.'))
              }
              try {
                value = value ? value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null
              } catch (error) {
                value = null
                console.log(error)
              }
            }
            return value
          }
          headerNode.editable = false
          return headerNode
        }

        const countHeaders = cloneDeep(headers)
        countHeaders.forEach(h => removeCellStyle(h))
        this.countColumnDefs = countHeaders
      }

      let allData = []
      responses.forEach(r => {
        allData = Object.entries(r.data.data[0]).length === 0 ? allData : allData.concat(r.data.data[0].Data)
      })

      allData = allData.sort((a, b) => {
        if (a.referenciaContrato !== b.referenciaContrato) {
          return a.referenciaContrato.localeCompare(b.referenciaContrato)
        }
        if (a.referencia !== b.referencia) {
          return a.referencia.localeCompare(b.referencia)
        }
        return a.candidato.localeCompare(b.candidato)
      })

      if (this.obraIdFiltro && allData.length === 0) {
        toast.warning(this.$lang.PCI.Spreadsheet.WorkNotInSheet)
      }

      let lastReferencia = null
      let itemIndex = 0

      data.Data = allData.map(row => {
        let item = null
        if (row.referencia !== lastReferencia) {
          itemIndex++
          item = itemIndex
        }
        lastReferencia = row.referencia
        return {
          ...row,
          item
        }
      })

      loading.close()

      this.$nextTick(() => {
        if (data) {
          setTimeout(() => {
            if (getHeaders) {
              this.onLoadLayout()
            }
            this.updatingLayout = false
            this.$nextTick(() => {
              this.loadGridValues(data)
              this.showGrid = true
            })
          }, 300)
        }
      })
    },
    loadQuotes () {
      let contracts = this.rowData.reduce((acc, curr) => {
        if (!acc.includes(curr.idContrato)) {
          acc.push(curr.idContrato)
        }
        return acc
      }, [])
      TecAnalysisRepository.GetAllQuoteByContract({params: {contratoID: contracts}, paramsSerializer: {indexes: null}})
        .then(response => {
          if (response.data.code > 0) {
            let contractRefs = this.rowData.reduce((acc, curr) => {
              acc[curr.idContrato] = curr[curr.idContrato] || curr.referenciaContrato
              return acc
            }, {})
            this.quotes = response.data.data.reduce((acc, curr) => {
              const ctr = contractRefs[curr.analiseTecCotacao.contratoID]
              const status = curr.statusAprovacao === 18 ? 16 : curr.statusAprovacao
              acc[ctr] = acc[ctr] || {}
              acc[ctr][status] = (acc[ctr][status] || 0) + 1
              acc['Total'] = (acc['Total'] || 0) + 1
              return acc
            }, {})
          }
        })
    },
    onUpdateTecAnalysis (works) {
      this.loadQuotes()
      const promises = [Promise.resolve()]
      works.forEach(wk => {
        promises.push(
          WorkPCIRepository.Automatization(wk.obraID)
            .finally(() => {
              promises.push(WorkPCIRepository.Validation(wk.obraID))
            })
        )
      })
      Promise.all(promises)
        .finally(() => {
          this.loadGridRowValues()
        })
        .then(() => this.loadQuotes())
    },
    reprocessLine (rowIdx) {
      const rowIndex = rowIdx || this.gridApi.getFocusedCell().rowIndex
      const row = this.gridApi.rowModel.getRow(rowIndex)
      const item = row.data.item

      WorkPCIRepository.Automatization(row.data.obraId)
        .finally(() => {
          WorkPCIRepository.Validation(row.data.obraId)
            .finally(() => {
              PCIRepository.GetAlerts(this.pciId)
                .then(response => {
                  if (response.data.code > 0) {
                    this.alerts = this.alertasDoFiltro(response.data.data)
                    // this.onFilterAlertRows(this.alertFilter)
                  }
                })
                .finally(() => {
                  if (!window.work2Automatization[row.data.obraId]) {
                    PCIRepository.GetPCIWork(row.data.obraId)
                      .then(response => {
                        if (response.data.code > 0) {
                          response.data.data[0].Data[0].item = item
                          this.gridApi.applyTransactionAsync({ update: [...response.data.data[0].Data] })
                          this.gridPCI.refreshCells()
                        }
                      })
                  }
                })
            })
        })

      this.restoreFocus()
    },
    onUpdateStoppage () {
      this.showStoppage = false
      this.reprocessLine()
    },
    onUpdateCancellation () {
      this.showCancellation = false
      const rows = {}
      this.gridApi.getCellRanges().forEach(r => {
        for (var x = r.startRow.rowIndex; x <= r.endRow.rowIndex; x++) {
          rows[x] = true
        }
      })
      Object.keys(rows).forEach(r => {
        this.reprocessLine(r)
      })
    },
    onUpdateTecAnalysisNa () {
      this.loadGridRowValues()
    },
    onFilterRow () {
      if (this.rowFiltered) {
        const currentColumn = this.gridApi.getFocusedCell()
        this.gridApi.clearRangeSelection()
        this.gridApi.setFilterModel(null)
        this.filterSelected = null
        this.$nextTick(() => {
          this.gridApi.setFocusedCell(this.rowFiltered.rowIndex, currentColumn.column.colId)
          this.rowFiltered = null
        })
      } else {
        if (this.gridApi.getFocusedCell()) {
          this.rowFiltered = this.gridApi.getFocusedCell()
          const referencia = []
          this.gridApi.getCellRanges().forEach(r => {
            for (var x = r.startRow.rowIndex; x <= r.endRow.rowIndex; x++) {
              const row = this.gridApi.rowModel.getRow(x)
              referencia.push(row.data.referencia)
            }
          })
          const filter = {'referencia': {'filterType': 'multi', 'filterModels': [null, {'values': referencia, 'filterType': 'set'}]}}
          this.gridApi.setFilterModel(filter)
        }
      }
    },
    onFilterAlertRows (alertGroup = null) {
      this.isFilteringAlerts = true
      let filter = this.alertUnfilter || this.gridApi.getFilterModel()
      let alertsFiltered = this.alerts
      if (alertGroup) {
        if (this.alertFilter === alertGroup) {
          this.alertFilter = null
          this.alertUnfilter = null
        } else {
          this.alertFilter = this.alertGroups.filter(g => g.id === alertGroup.id)[0]
          this.alertUnfilter = this.alertUnfilter || this.gridApi.getFilterModel()
          alertsFiltered = this.alerts
            .filter(alert => alert.pciModeloItemValid && ((alertGroup.id && alert.pciModeloItemValid.alertaGrupoID === alertGroup.id) || (!alertGroup.id && !alert.pciModeloItemValid.alertaGrupoID)))
          const values = alertsFiltered
            .map(a => {
              const work = this.rowData.filter(pci => pci.obraId === a.obraID)[0]
              if (work) {
                return work.referencia
              }
            })
          filter = {'referencia': {'filterType': 'multi', 'filterModels': [null, {'values': [...values], 'filterType': 'set'}]}}
        }
      }
      this.onChangeFilter({filter: filter}, this.alertFilter)
      this.alertsFiltered = alertsFiltered
      // this.showAlerts = false
      setTimeout(() => {
        this.isFilteringAlerts = false
      }, 500)
    },
    onAlertClicked (alert) {
      let columnAlerted = this.columnApi.getColumn(alert.pciModeloItemValid.pciModeloItemID)
      let rowNodeAlerted = null

      const findChildrenNode = (childrens) => {
        childrens.forEach(n => {
          if (!rowNodeAlerted && n.group) {
            findChildrenNode(n.childrenAfterFilter)
          } else if (!n.group) {
            if (n.data.obraId === alert.obraID) {
              this.gridApi.setRowNodeExpanded(n, true, true)
              this.$nextTick(() => {
                rowNodeAlerted = n
              })
            }
          }
        })
      }

      this.gridApi.forEachNodeAfterFilter(n => {
        if (!rowNodeAlerted && n.group) {
          findChildrenNode(n.childrenAfterFilter)
        } else if (!n.group) {
          if (n.data.obraId === alert.obraID) {
            rowNodeAlerted = n
          }
        }
      })

      if (!columnAlerted.visible) {
        this.columnApi.setColumnVisible(alert.pciModeloItemValid.pciModeloItemID, true)
      }
      if (!rowNodeAlerted) {
        console.log('filtro escondendo')
        const filter = {}
        this.gridApi.setFilterModel(filter)
      }

      this.gridApi.ensureColumnVisible(columnAlerted, 'middle')
      this.gridApi.ensureIndexVisible(rowNodeAlerted.rowIndex, 'middle')
      this.showAlerts = false
    },
    onDownloadFile () {
    },
    onDeleteFile () {
    },
    loadImages () {
    },
    onShowAlerts () {
      if (this.alerts.length) {
        this.showAlerts = !this.showAlerts
      }
      this.showQuotes = false
    },
    onShowQuotes () {
      this.showQuotes = !this.showQuotes
      this.showAlerts = false
    },
    onFilterChanged (params) {
      // const data = params.api.rowModel.rowsToDisplay.map(r => r.data)
      this.calculateTotals()
      if (!this.isFilteringAlerts) {
        this.alertFilter = null
        this.alertsFiltered = this.alerts
      } else {
        this.isFilteringAlerts = false
      }
      if (params.api.isAnyFilterPresent()) {
        let filterText = ''
        const filterModel = params.api.getFilterModel()

        let sepInside = ''
        Object.keys(filterModel).forEach(field => {
          const colDef = params.api.getColumnDef(field)
          const fieldHeader = `[${colDef.headerName}]`

          const processFilter = (filter) => {
            if (filter === null) return
            if (filter.filterType === 'set') {
              let values = filter.values
              if (colDef.type === 'dateColumn') {
                values = filter.values.map(dt => {
                  const date = dt ? moment(dt).toDate().toLocaleDateString() : ''
                  return date
                })
              }
              filterText += ` ${sepInside}${fieldHeader} ${'(' + values.join(', ') + ')'} `
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            } else if (filter.operator) {
              sepInside = '('
              processFilter(filter.condition1)
              sepInside = ` ${this.$lang.AGGrid[filter.operator.toLowerCase() + 'Condition']} `
              processFilter(filter.condition2)
              filterText += ')'
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            } else {
              let condType = this.$lang.AGGrid[filter.type]
              let condFilter
              if (filter.type === 'blank' || filter.type === 'notBlank') {
                condFilter = ''
                condType = filter.type
              } else if (filter.filterType === 'date') {
                const dateFrom = filter.dateFrom ? moment(filter.dateFrom).toDate().toLocaleDateString() : ''
                condFilter = `"${dateFrom}"`
              } else {
                condFilter = `"${filter.filter}"`
              }
              filterText += ` ${sepInside}${fieldHeader} ${condType} ${condFilter} `
              sepInside = ` ${this.$lang.AGGrid.andCondition} `
            }
          }

          if (filterModel[field].filterType === 'multi') {
            filterModel[field].filterModels.forEach(filter => {
              processFilter(filter)
            })
          } else {
            const filter = filterModel[field]
            processFilter(filter)
          }
        })

        const filterObj = {label: filterText, filter: filterModel}
        if (!this.filterList.some(obj => {
          return isEqual(obj.filter, filterObj.filter)
        })) {
          this.filterList.push(filterObj)
        }
        this.filterSelected = filterObj
      } else {
        this.filterText = null
        this.filterSelected = null
      }
    },
    onChangeFilter (params, alertFilter = null) {
      this.alertFilter = alertFilter
      this.alertUnfilter = !params ? null : this.alertUnfilter
      this.gridApi.setFilterModel(params ? params.filter : null)
    },
    withPopper (dropdownList, component, { width }) {
      dropdownList.style.width = width

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    },
    onFirstDataRendered (params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi

      this.$nextTick(() => {
        this.columnApi.autoSizeAllColumns(false)
        this.updatingLayout = false
      })
    },
    onSaveLayout () {
      if (!this.updatingLayout) {
        loading.push()
        PCILayoutContaRepository.Create({
          PCIID: this.pciId[0],
          Layout: JSON.stringify(this.columnApi.getColumnState())
        })
          .catch(err => console.log(err))
          .finally(() => loading.close())
      }
    },
    onToolPanelVisibleChanged (params) {
      if (params.source === 'layout') {
        const panel = params.api.getToolPanelInstance('layout')
        panel.onLoad(this.pciId)
      }
    },
    onLoadLayout () {
      const originalState = this.pciDataGridOptions.api.columnModel.getColumnState()
      this.originalColState = originalState.map(col => {
        return {
          colId: col.colId,
          pinned: col.pinned
        }
      })
      PCILayoutContaRepository.Get(this.pciId[0])
        .then(response => {
          if (response.data.code > 0) {
            const layout = JSON.parse(response.data.data.layout)

            const cols = []
            this.gridApi.getColumnDefs().map(c => {
              const getObj = (col) => {
                if (col.children) {
                  col.children.forEach(cl => getObj(cl))
                } else {
                  cols.push(col)
                }
              }
              getObj(c)
              return cols
            })

            cols.forEach((c, idx) => {
              if (!layout.some(l => l.colId === c.colId)) {
                layout.splice(idx, 0, {
                  aggFunc: null,
                  colId: c.colId,
                  flex: null,
                  hide: true,
                  pinned: c.pinned,
                  pivot: false,
                  pirotIndex: null,
                  rowGroup: c.rowGroup,
                  rowGroupIndex: c.rowGroupIndex,
                  sort: c.sort,
                  sortIndex: c.sortIndex,
                  width: c.width
                })
              }
            })

            this.columnApi.applyColumnState({ state: layout, applyOrder: false })
          }
        })
        .catch(err => console.log(err))
    },
    onShowAllColumns () {
      loading.push()
      setTimeout(() => {
        this.columnApi.setColumnsVisible(this.columnApi.getColumns(), true)
        loading.close()
      }, 100)
    },
    onRestorePinned () {
      this.columnApi.applyColumnState({ state: this.originalColState })
    },
    onShowConsiderations () {
      this.showConsiderations = true

      const contracts = this.gridApi.rowModel.nodeManager.rootNode.allLeafChildren.reduce((acc, value) => {
        if (acc.length === 0 || acc.filter(v => v.referenciaContrato === value.data.referenciaContrato).length === 0) {
          acc.push({
            referenciaContrato: value.data.referenciaContrato,
            contratoId: value.data.idContrato,
            pciId: value.data.pciId
          })
        }
        return acc
      }, [])

      this.$nextTick(() => {
        this.$refs.considerations.show(contracts)
      })
    },
    onShowAnnex () {
      this.showAnnex = true

      const contracts = this.gridApi.rowModel.nodeManager.rootNode.allLeafChildren.reduce((acc, value) => {
        if (acc.length === 0 || acc.filter(v => v.referenciaContrato === value.data.referenciaContrato).length === 0) {
          acc.push({
            referenciaContrato: value.data.referenciaContrato,
            contratoId: value.data.idContrato,
            pciId: value.data.pciId
          })
        }
        return acc
      }, [])

      this.$nextTick(() => {
        this.$refs.annex.show(contracts)
      })
    },
    onAutosizeAllColumns () {
      this.columnApi.autoSizeAllColumns()
    },
    getContextMenuItems (params) {
      if (!params.node) return []
      return [
        {
          name: 'Relatório Jurídico',
          action: () => { this.downloadLegalReport() },
          cssClasses: [document.querySelector('title').text.includes('JURÍDICO') || document.querySelector('title').text.includes('JUR-CONTRATOS') ? '' : 'd-none'],
          icon: '<i class="fas fa-balance-scale"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.SelectAll + ' ' + (params.column ? params.column.colDef.headerName : ''),
          action: () => { this.setChangeAll(params, 'true') },
          cssClasses: [(!params.column || params.column.colDef.type !== 'booleanColumn') ? 'd-none' : ''],
          icon: '<i class="fas fa-check"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.DeselectAll + ' ' + (params.column ? params.column.colDef.headerName : ''),
          action: () => { this.setChangeAll(params, 'false') },
          cssClasses: [(!params.column || params.column.colDef.type !== 'booleanColumn') ? 'd-none' : ''],
          icon: '<i class="fas fa-times"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ChangeWork,
          action: () => { this.viewAddress(params) },
          icon: '<i class="fas fa-map-marker-alt"></i>',
          cssClasses: [this.isRangeExtended() || !(this.hasRole(this.roles.RW_OPER_PCI_WORK)) ? 'd-none' : ''],
          shortcut: 'F7'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ViewTeam,
          action: () => { this.viewTeam() },
          icon: '<i class="fas fa-users"></i>',
          cssClasses: [this.isRangeExtended() ? 'd-none' : ''],
          shortcut: 'F8'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ViewBatchTeam,
          action: () => { this.viewBatchTeam() },
          icon: '<i class="fas fa-users"></i>',
          cssClasses: [!this.isRangeExtended() ? 'd-none' : ''],
          shortcut: 'F8'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ViewCandidates,
          action: () => { this.viewCandidates(params) },
          icon: '<i class="fas fa-map-marked-alt"></i>'
        },
        {
          name: this.$lang.PCI.Reports.Type2,
          action: () => { this.viewResume(params) },
          cssClasses: [this.isRangeExtended() || !(this.hasRole(this.roles.RW_OPER_PCI_REPORT)) ? 'd-none' : ''],
          icon: '<i class="fas fa-layer-group"></i>'
        },
        {
          name: this.$lang.PCI.COP.ViewOfficial,
          action: () => { this.viewCOPof(params) },
          icon: '<i class="fas fa-camera"></i>',
          cssClasses: [this.isRangeExtended() ? 'd-none' : ''],
          shortcut: 'F6'
        },
        {
          name: this.$lang.PCI.COP.PrintOfficial,
          action: () => { this.printAllCOP(params) },
          icon: '<i class="fas fa-camera"></i>',
          cssClasses: [this.isRangeExtended() ? '' : 'd-none']
        },
        {
          name: params.value !== '#NA#' ? this.$lang.PCI.Spreadsheet.SetNa : this.$lang.PCI.Spreadsheet.UnsetNa,
          action: () => { params.value !== '#NA#' ? this.setNA(params) : this.unsetNA(params) },
          icon: '<i class="fas fa-minus"></i>',
          cssClasses: [this.isRangeExtended() || (!params.column || !params.column.colDef.editable) ? 'd-none' : ''],
          shortcut: '[Ctrl+Alt+N]'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ToggleNa,
          action: () => { this.toggleNA() },
          icon: '<i class="fas fa-exchange-alt"></i>',
          cssClasses: [!this.isRangeExtended() ? 'd-none' : ''],
          shortcut: '[Ctrl+Alt+N]'
        },
        {
          name: this.$lang.PCI.AT.Title,
          action: () => { this.viewTecAnalysis() },
          icon: '<i class="fas fa-drafting-compass"></i>',
          cssClasses: [!(
            this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_FINANC) ||
            this.hasRole(this.roles.R_OPER_PCI_AT_READ)
          )
            ? 'd-none'
            : ''],
          shortcut: 'F9'
        },
        {
          name: this.$lang.PCI.AT.TitleQuote,
          action: () => { this.viewTecAnalysisQuote() },
          icon: '<i class="fas fa-pencil-ruler"></i>',
          cssClasses: [!(
            this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) ||
            this.hasRole(this.roles.RW_OPER_PCI_AT_FINANC) ||
            this.hasRole(this.roles.R_OPER_PCI_AT_READ)
          )
            ? 'd-none'
            : '']
          //   ,
          // shortcut: 'F9'
        },
        {
          name: this.$lang.PCI.ATNA.Title,
          action: () => { this.viewTecAnalysisNa(params) },
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) || this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET)) ? 'd-none' : ''],
          icon: '<i class="fas fa-drafting-compass text-danger"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.WorkStoppage,
          action: () => { this.viewStoppage(params) },
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_STOPPAGE) && params.node.data && params.node.data.inicioObraParalisacao) ? 'd-none' : ''],
          icon: '<i class="fas fa-pause"></i>'
        },
        // {
        //   name: this.$lang.PCI.Spreadsheet.WorkRainStoppage,
        //   action: () => { this.viewRainStoppage(params) },
        //   cssClasses: [this.hasRole(this.roles.RW_OPER_PCI_STOPPAGE) && params.node.data && params.node.data.inicioObraParalisacao && !params.node.data.terminoReal && (!params.node.data.paralisacaoInicio || (params.node.data.paralisacaoInicio && params.node.data.paralisacaoRetorno)) ? '' : 'd-none'],
        //   icon: '<i class="fas fa-cloud-showers-heavy"></i>'
        // },
        {
          name: this.$lang.PCI.Spreadsheet.WorkCancellation,
          action: () => { this.viewCancellation() },
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_STOPPAGE) && this.getCancellableRows().length) ? 'd-none' : ''],
          icon: '<i class="fas fa-ban"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.HistoricUpdate,
          action: () => { this.viewPciItemLog(params) },
          icon: '<i class="fas fa-history"></i>',
          cssClasses: [(params.column && !params.column.colDef.editable) ? 'd-none' : ''],
          shortcut: '[Ctrl+Alt+H]'
        },
        {
          name: this.$lang.PCI.Spreadsheet.SetNaPDR,
          action: () => { this.setPDRNA(params) },
          icon: '<i class="fas fa-minus"></i>',
          cssClasses: [params.node.data && params.node.data.statuspdr !== '#NA#' && this.hasRole(this.roles.RW_OPER_PCI_PDR_NA) && !this.isRangeExtended() && params.node.data.statuspdr <= '0' ? '' : 'd-none']
        },
        {
          name: this.$lang.PCI.Spreadsheet.UnsetNaPDR,
          action: () => { this.unsetPDRNA(params) },
          icon: '<i class="fas fa-minus"></i>',
          cssClasses: [params.node.data && params.node.data.statuspdr === '#NA#' && this.hasRole(this.roles.RW_OPER_PCI_PDR_NA_DELETE) && !this.isRangeExtended() ? '' : 'd-none']
        },
        {
          name: this.$lang.PCI.Spreadsheet.ReleasePDR,
          action: () => { this.createPDR(params) },
          icon: '<i class="far fa-thumbs-up"></i>',
          cssClasses: [!this.isRangeExtended() && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION) && params.node.data && params.node.data.terminoReal && (params.node.data.statuspdr <= '0') ? '' : 'd-none'],
          shortcut: '[Ctrl+Alt+L]'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ApprovePDR,
          action: () => { this.authorizePDR(params) },
          icon: '<i class="far fa-thumbs-up"></i>',
          cssClasses: [!this.isRangeExtended() && params.node.data && params.node.data.statuspdr === '1' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION_APPROVE) ? '' : 'd-none'],
          shortcut: 'F2'
        },
        {
          name: this.$lang.PCI.Spreadsheet.RejectPDR,
          action: () => { this.rejectPDR(params) },
          icon: '<i class="fas fa-thumbs-down"></i>',
          cssClasses: [!this.isRangeExtended() && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION) && params.node.data && params.node.data.statuspdr === '1' ? '' : 'd-none'],
          shortcut: '[Ctrl+Alt+R]'
        },
        {
          name: this.$lang.PCI.Spreadsheet.HistoricPDR,
          action: () => { this.viewPdrLog(params) },
          icon: '<i class="fas fa-history"></i>',
          cssClasses: [!this.isRangeExtended() && params.node.data && params.node.data.statuspdr !== '0' ? '' : 'd-none'],
          shortcut: '[Ctrl+Alt+H]'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ZeroRating,
          action: () => { this.zeroPDR(params) },
          icon: '<i class="fa fa-circle"></i>',
          cssClasses: [!this.isRangeExtended() && params.node.data && params.node.data.statuspdr === '1' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION_APPROVE) ? '' : 'd-none']
        },
        'separator',
        {
          name: this.$lang.PCI.PO.Title,
          action: () => { this.viewPO(params) },
          icon: '<i class="fas fa-file-invoice-dollar"></i>',
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_PURCHASE)) ? 'd-none' : ''],
          shortcut: 'F3'
        },
        {
          name: this.$lang.PCI.Bills.Title,
          action: () => { this.viewBills(params) },
          icon: '<i class="fas fa-file-invoice-dollar"></i>',
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_BILLS)) ? 'd-none' : ''],
          shortcut: 'F4'
        },
        {
          name: this.$lang.PCI.PurchaseOrder.Title,
          action: () => { this.viewPurchaseOrder(params) },
          icon: '<i class="fas fa-store"></i>',
          cssClasses: [!(this.hasRole(this.roles.RW_OPER_PCI_PURCHASE)) ? 'd-none' : ''],
          shortcut: 'F5'
        },
        'separator',
        {
          name: this.$lang.PCI.Spreadsheet.ExcelExport,
          action: () => { this.exportExcel(params) },
          icon: '<i class="far fa-file-excel"></i>'
        },
        {
          name: `${this.$lang.PCI.Spreadsheet.ExcelExport} (Rel. ${this.$lang.PCI.Spreadsheet.ViewTeam})`,
          action: () => { this.exportTeamExcel(params) },
          icon: '<i class="far fa-file-excel"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.OpenPDRinPdf,
          action: () => { this.printPdf(params.node.data.obraId) },
          cssClasses: [this.hasRole(this.roles.R_OPER_PCI_PDR_VALUES) && params.node.data && params.node.data.statuspdr === '20' ? '' : 'd-none'],
          icon: '<i class="far fa-file-pdf"></i>'
        },
        'separator',
        {
          name: this.$lang.PCI.Spreadsheet.AbrirZdocs,
          action: () => { this.showZdocsFolder({obraId: params.node.data.obraId, gedPastaId: params.node.data.gedPastaId}) },
          cssClasses: [params.node.data && params.node.data.gedPastaId ? '' : 'd-none'],
          icon: '<i class="far fa-folder"></i>',
          shortcut: 'F11'
        },
        {
          name: this.$lang.PCI.Spreadsheet.VincularZdocs,
          action: () => { this.selectZdocsFolder(params.node.data.obraId) },
          icon: '<i class="fas fa-folder-plus"></i>',
          shortcut: 'F10'
        }
      ]
    },
    processDataFromClipboard (params) {
      if (params.data[0].length > 1) {
        toast.error(this.$lang.PCI.Spreadsheet.PasteMultiColumnNotAllowed)
        return null
      }
      if (params.data[params.data.length - 1][0] === '') {
        params.data.splice(params.data.length - 1, 1)
      }
      var x
      if (this.gridApi.getFocusedCell().column.colDef.type === 'integerColumn') {
        for (x = 0; x < params.data.length; x++) {
          let value
          if (params.data[x][0].includes(',')) {
            value = parseFloat(params.data[x][0].replaceAll('.', '').replaceAll(',', '.').replaceAll('R$', '').trim())
          } else if (!params.data[x][0].match(/^\d*\.\d{2}$/g)) {
            value = parseFloat(params.data[x][0].replaceAll('.', '').replaceAll('R$', '').trim())
          } else {
            value = parseFloat(params.data[x][0])
          }
          if (Number.isNaN(value)) {
            toast.error(this.$lang.Common.Alerts.InvalidValue)
            return null
          }
          params.data[x][0] = value.toFixed(0)
        }
      } else if (this.gridApi.getFocusedCell().column.colDef.type === 'numberColumn') {
        for (x = 0; x < params.data.length; x++) {
          let value
          if (params.data[x][0].includes(',')) {
            value = parseFloat(params.data[x][0].replaceAll('.', '').replaceAll(',', '.').replaceAll('R$', '').trim())
          } else if (!params.data[x][0].match(/^\d*\.\d{2}$/g)) {
            value = parseFloat(params.data[x][0].replaceAll('.', '').replaceAll('R$', '').trim())
          } else {
            value = parseFloat(params.data[x][0])
          }
          if (Number.isNaN(value)) {
            toast.error(this.$lang.Common.Alerts.InvalidValue)
            return null
          }
          params.data[x][0] = value.toFixed(2)
        }
      } else if (this.gridApi.getFocusedCell().column.colDef.type === 'dateColumn') {
        for (x = 0; x < params.data.length; x++) {
          const data = params.data[x][0]
          if (data !== '') {
            const mt1 = data.match(/^\d{2}\/\d{2}\/\d{4}$/g)
            const mt2 = data.match(/^\d{2}\/\d{2}\/\d{2}$/g)
            const mt3 = data.match(/^\d{4}-\d{2}-\d{2}/g)
            const mt4 = data.match(/^\d{1}\/\d{1}\/\d{4}$/g)
            const mt5 = data.match(/^\d{2}\/\d{1}\/\d{4}$/g)
            const mt6 = data.match(/^\d{1}\/\d{2}\/\d{4}$/g)
            let date
            let format

            if (mt1 || mt2 || mt3 || mt4 || mt5 || mt6) {
              if (mt1) format = 'DD/MM/YYYY'
              if (mt2) format = 'DD/MM/YY'
              if (mt4) format = 'D/M/YYYY'
              if (mt5) format = 'DD/M/YYYY'
              if (mt6) format = 'D/MM/YYYY'

              date = moment(data, format, true)
            }

            if (date && date.isValid()) {
              params.data[x][0] = date.toDate().toISOString().substring(0, 10)
            } else {
              toast.error(this.$lang.Common.Alerts.InvalidDate)
              return null
            }
          }
        }
        return params.data
      } else if (this.gridApi.getFocusedCell().column.colDef.type === 'valuesColumn') {
        var found = true
        for (x = 0; x < params.data.length; x++) {
          found = found & this.gridApi.getFocusedCell().column.colDef.cellEditorParams.values.includes(params.data[x][0])
        }
        if (!found) {
          toast.error(this.$lang.Common.Alerts.InvalidValue)
          return null
        }
      }
      return params.data
    },
    processCellForClipboard (params) {
      if (params.column.colDef.type === 'numberColumn') {
        if (params.value) {
          return parseFloat(params.value).toLocaleString()
        }
      } else if (params.column.colDef.type === 'dateColumn') {
        if (params.value) {
          return moment(params.value).toDate().toLocaleDateString()
        }
      } else if (params.column.colDef.type === 'memoColumn') {
        if (params.value) {
          let result = `"${params.value.replaceAll('"', '\'\'')}"`
          const cellRanges = params.api.getCellRanges()
          const lastRow = cellRanges[cellRanges.length - 1]
          if (lastRow.endRow.rowIndex === params.node.rowIndex && lastRow.columns[lastRow.columns.length - 1].colId === params.column.colId) {
            result += '\r\n'
          }
          return result
        }
      } else {
        return params.value
      }
    },
    columnIsPDR (column) {
      const fieldsNotAction = ['statuspdr', 'libavaliacaopdr', 'rejeicaopdr', 'autorizacaopdr', 'conclusaopdr']
      return fieldsNotAction.includes(column)
    },
    setNA (row) {
      let field
      if (row) {
        field = row.column.colDef.field
      } else {
        field = this.gridApi.getFocusedCell().column.colDef.field
        row = {node: this.gridApi.rowModel.getRow(this.gridApi.getCellRanges()[0].startRow.rowIndex)}
      }
      row.node.setDataValue(field, '#NA#')
    },
    unsetNA (row) {
      let field
      if (row) {
        field = row.column.colDef.field
      } else {
        field = this.gridApi.getFocusedCell().column.colDef.field
        row = {node: this.gridApi.rowModel.getRow(this.gridApi.getCellRanges()[0].startRow.rowIndex)}
      }
      row.node.setDataValue(field, null)
    },
    onSelectPdrFormulario (form) {
      // chamado 20103: era .find, ou seja desmarcava UM homonimo so. Mesmo funcionario em 3 membros
      // de obra deixava 2 marcados e a PDR nascia com a pessoa duplicada.
      this.montagemPdrList
        .filter(m => m.membro.id !== form.membro.id && m.membro.funcionarioId === form.membro.funcionarioId)
        .forEach(m => {
          if (m.membro.funcionario && m.membro.funcionario.cargo) {
            m.membro.funcionario.cargo.pdr = false
          }
        })
    },
    funcionariosDuplicadosPdr () {
      // chamado 20103: o mesmo funcionario pode vir em mais de um ObraMembro da obra (troca de
      // funcao, reimportacao) e o PDRFormularioID nunca e limpo, entao o vinculo antigo continua
      // marcado. Se dois entrarem na PDR, a pessoa nasce duplicada e cada copia recebe o jogo
      // completo de lancamentos. Aqui so DETECTA - quem escolhe qual membro fica e o usuario, pelo
      // select de formulario (onSelectPdrFormulario desmarca os homonimos).
      const porFuncionario = {}

      this.montagemPdrList.forEach(item => {
        const membro = item.membro

        if (!membro || !membro.funcionario || !membro.funcionario.cargo || !membro.funcionario.cargo.pdr) {
          return
        }

        porFuncionario[membro.funcionarioId] = (porFuncionario[membro.funcionarioId] || []).concat(membro.nome)
      })

      return Object.keys(porFuncionario)
        .filter(id => porFuncionario[id].length > 1)
        .map(id => porFuncionario[id][0])
    },
    createPDR (row) {
      // chamado 20121: liberar a avaliacao congela o COP na pratica - depois disso o pessoal do
      // COP nao mexe mais. Antes de abrir os formularios, checa se sobrou pendencia de aprovacao
      // (campo, anexo ou observacao geral em situacao 1/2/3) e pede confirmacao explicita.
      // Falha na checagem NAO trava a liberacao: avisa e segue (o aviso e advisory, o servidor
      // nao muda de comportamento por causa dele).
      COPModeloObraItemPrRepository.GetPendencias(row.node.data.obraId)
        .then(response => {
          const pendencias = response.data || {}

          if ((pendencias.total || 0) > 0) {
            this.copPendencias = {
              aguardando: pendencias.aguardando || 0,
              aprovadoSupervisor: pendencias.aprovadoSupervisor || 0,
              aprovadoCoordenador: pendencias.aprovadoCoordenador || 0,
              total: pendencias.total
            }
            this.copPendenciasRow = row
            this.showCopPendenciasConfirm = true
            return
          }

          this.openPdrMontage(row)
        })
        .catch(() => {
          // abre ANTES do toast: se a mensagem falhar (catalogo de idioma incompleto), a
          // liberacao nao pode ficar presa por causa do aviso.
          this.openPdrMontage(row)
          toast.warning(this.$lang.PCI.PDRForm.CopPendencias.CheckFailed)
        })
    },
    confirmCopPendencias () {
      const row = this.copPendenciasRow
      this.copPendenciasRow = null

      if (row) this.openPdrMontage(row)
    },
    openPdrMontage (row) {
      PDRRepository.GetMontage(row.node.data.obraId)
        .then((response) => {
          this.montagemPdrList = response.data.data
          this.pciObraIdPdrTeam = row.node.data.id
          this.rowSelectedPdr = row
          this.showPdrTeam = true
        })
    },
    zeroPDR (row) {
      this.showZeroPDR = true
      this.rowSelectedPdr = row
    },
    submitZeroPDR (modal) {
      if (!this.zeroReason) {
        modal.preventDefault()
        toast.error('Preencha o motivo do zeramento')
        return
      }

      loading.push()
      PDRAvaliacaoRepository.SetZeroAppraisalPDF(this.rowSelectedPdr.node.data.obraId, {observacao: this.zeroReason})
        .then(() => {
          // this.rowSelectedPdr.node.setDataValue('statuspdr', '20', 'blockEdit')
          toast.success(this.$lang.Common.Alerts.Success)
          this.reprocessLine()
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          this.zeroReason = null
          this.rowSelectedPdr = null
          loading.close()
        })
    },
    setData (folder, response) {
      this.$refs.tableGrid.LoadAllByData(response)
      this.objList = response ? response.data.data : []
      this.folder = folder
    },
    rejectPDR (row) {
      this.showRejectPDR = true
      this.rowSelectedPdr = row
    },
    submitRejectPDR (modal) {
      if (!this.rejectReason) {
        modal.preventDefault()
        toast.error('Preencha o motivo da rejeição')
        return
      }

      loading.push()
      PDRRepository.Reject({ PCIObraID: this.rowSelectedPdr.node.data.id, Observacao: this.rejectReason })
        .then((response) => {
          const pdrForm = response.data.data
          this.rowSelectedPdr.node.setDataValue('rejeicaopdr', pdrForm.rejeicaoAvaliacao, 'blockEdit')
          this.rowSelectedPdr.node.setDataValue('statuspdr', '-1', 'blockEdit')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
        .then(() => this.reprocessLine())
    },
    onCloseAuthorizePDR () {
      this.showAuthorizePDR = false
    },
    onCloseTeam () {
      this.showConstructionTeam = false
    },
    authorizePDR (row) {
      PDRRepository.GetMontage(row.node.data.obraId)
        .then((response) => {
          this.montagemPdrList = response.data.data
          this.authorizePDRModal.observation = ''
          this.showAuthorizePDR = true
        })
    },
    submitAuthorizePDR () {
      loading.push()

      const rowIndex = this.pciDataGridOptions.api.getCellRanges()[0].startRow.rowIndex
      const row = this.pciDataGridOptions.api.rowModel.getRow(rowIndex)

      PDRRepository.Authorize({id: row.data.id, obs: this.authorizePDRModal.observation})
        .then((response) => {
          const pdrForm = response.data.data
          row.setDataValue('autorizacaopdr', pdrForm.autorizacaoAvaliacao, 'blockEdit')
          row.setDataValue('statuspdr', '2', 'blockEdit')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          this.authorizePDRModal.observation = ''
          loading.close()
        })
        .then(() => this.reprocessLine())
    },
    setPDRNA (row) {
      this.rowSetNA = row
      this.showPdrSetNAReason = true
      this.pdrNaReason = ''
    },
    unsetPDRNA (row) {
      if (confirm(this.$lang.PCI.PDRSetNAReason.ConfirmUnSet) === true) {
        loading.push()
        PDRRepository.Delete(row.node.data.id)
          .then(response => {
            if (response.data.code > 0) {
              row.node.setDataValue('statuspdr', response.data.data.status, 'blockEdit')
              toast.success(this.$lang.Common.Alerts.Success)
            } else {
              toast.error(response.data.message)
            }
          })
          .catch(() => {
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
          .then(() => this.reprocessLine())
      }
    },
    submitPDRSetNA (modal) {
      // console.log(this.rowSetNA.node.data.id)
      PDRRepository.SetNA(this.rowSetNA.node.data.id, {Observacao: this.pdrNaReason})
        .then(response => {
          if (response.data.code > 0) {
            console.log(PDRRepository.SetNA)
            this.rowSetNA.node.setDataValue('statuspdr', '#NA#', 'blockEdit')
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.erro(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
        .then(() => this.reprocessLine())
    },
    submitPDR (modal) {
      let valido = true
      for (const item of this.montagemPdrList) {
        valido = valido && (!item.membro.funcionario || !item.membro.funcionario.cargo.pdr || (item.formularioSelecionado != null && item.membro.funcionario != null))
      }

      if (!valido) {
        modal.preventDefault()
        toast.error('Preencha todos os formulários para gerar a PDR')
        return
      }

      // chamado 20103: trava antes do POST /PDR. Gerar com o mesmo funcionario em dois membros
      // cria a pessoa duplicada na PDR, cada copia com o jogo completo de lancamentos. Saida pro
      // usuario: escolher o formulario do membro correto, o que desmarca os homonimos.
      const duplicados = this.funcionariosDuplicadosPdr()

      if (duplicados.length) {
        modal.preventDefault()
        toast.error(`Funcionário em mais de um membro desta obra: ${duplicados.join(', ')}. Escolha o formulário do membro correto antes de gerar a PDR.`)
        return
      }

      loading.push()
      PDRRepository.Create({
        ObraID: this.pciObraIdPdrTeam,
        Formulario: this.montagemPdrList
      })
        .then((response) => {
          const pdrForm = response.data.data
          this.rowSelectedPdr.node.setDataValue('libavaliacaopdr', pdrForm.liberacaoAvaliacao, 'blockEdit')
          this.rowSelectedPdr.node.setDataValue('statuspdr', '1', 'blockEdit')
          toast.success(this.$lang.Common.Alerts.Success)
          this.showAfterGeneratePDRexecute()
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
    },
    fillDetailModal (releaseDate, work) {
      let dateFormater = (date) => {
        if (date) return new Date(date).toLocaleDateString()
        return ''
      }
      let toDays = (date) => parseInt(new Date(date) / (1000 * 60 * 60 * 24))
      let calculateLateDays = (releaseDate) => {
        if (work.node.data.terminoReal) {
          let curDays = toDays(new Date(releaseDate) - new Date(work.node.data.terminoReal))
          curDays = curDays < 0 ? 0 : curDays
          return curDays
        }
        return 0
      }
      let isLate = (releaseDate) => {
        if (work.node.data.terminoReal) {
          return toDays(releaseDate) > (toDays(work.node.data.terminoReal) + this.afterGeneratePDRModal.daysToLate)
        }
        return false
      }

      this.afterGeneratePDRModal.startDate = dateFormater(work.node.data.inicioReal)
      this.afterGeneratePDRModal.endDate = dateFormater(work.node.data.terminoReal)
      this.afterGeneratePDRModal.releaseDate = dateFormater(releaseDate)
      this.afterGeneratePDRModal.lateDays = calculateLateDays(releaseDate)
      this.afterGeneratePDRModal.isLate = isLate(releaseDate)
      this.afterGeneratePDRModal.workID = work.node.data.id
    },
    showAfterGeneratePDRexecute () {
      this.fillDetailModal(Date.now(), this.rowSelectedPdr)
      this.afterGeneratePDRModal.observation = ''
      this.afterGeneratePDRModal.isReadOnly = false
      this.afterGeneratePDRModal.title = this.$lang.PCI.PDRForm.TableFields.PDRrelease
      this.afterGeneratePDRModal.confirmButton = this.$lang.Common.Buttons.Save
      this.showAfterGeneratePDR = true
    },
    submitAfterGeneratePDR () {
      if (this.afterGeneratePDRModal.isReadOnly) {
        return
      }
      loading.push()
      PDRRepository.PatchBuildObservation(
        this.afterGeneratePDRModal.workID,
        { Observacao: this.afterGeneratePDRModal.observation })
        .then((response) => {
          toast.success(this.$lang.PCI.PDRForm.TableFields.ObsSaveMessage)
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
        })
        .then(() => this.reprocessLine())
    },
    exportExcel (params) {
      const content = [{
        cells: params.columnApi.getAllDisplayedColumns().map(col => {
          let value = this.pciCountGridOptions.api.rowModel.getRow(0).data[col.colId]
          let style = 'rowCount'

          return {
            styleId: style,
            data: {
              value: value,
              type: 'Number'
            }
          }
        })
      },
      {
        cells: params.columnApi.getAllDisplayedColumns().map(col => {
          const totalize = this.headersTotalize[col.colId]

          let value = null
          let style = 'rowSum'

          if (totalize === 'sum') {
            value = parseFloat(this.pciCountGridOptions.api.rowModel.getRow(1).data[col.colId]) // .toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
          }
          return {
            styleId: style,
            data: {
              value: value,
              type: 'Number'
            }
          }
        })
      }]
      const self = this
      const excelParams = {
        appendContent: content,
        autoConvertFormulas: true,
        processCellCallback (params) {
          if (params.column.colDef.field === 'atStatus') {
            return params.value === '0' ? '' : self.$lang.PCI.AT['Status' + params.value]
          }

          if (params.column.colDef.field === 'statuspdr') {
            return self.$lang.PCI.PDR.Status['_' + params.value]
          }

          if (params.column.colDef && (params.column.colDef.type === 'numberColumn' || params.column.colDef.type === 'numberZeroColumn' || params.column.colDef.type === 'dateColumn' || params.column.colDef.type === 'integerColumn')) {
            if (params.value === '#NA#' || params.value === '#NREF#') {
              return '=NA()'
            }
          }

          return params.value
        }
      }

      this.gridApi.exportDataAsExcel(excelParams)
    },
    exportTeamExcel (params) {
      loading.push()
      PCIRepository.ExportTeamExcel(this.pciId)
        .then(response => {
          if (response.data.code > 0) {
            const data = Uint8Array.from(atob(response.data.data.file), c => c.charCodeAt(0))
            const blob = new Blob([data], {type: response.data.data.contentType})
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.data.data.name
            link.click()
            URL.revokeObjectURL(link.href)
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    viewCOPof (params) {
      if (process.env.UseSmartPciCop) {
        this.$nextTick(() => {
          this.showCopSmart = true
          this.$nextTick(() => {
            this.$refs.copSmart.show(params.node.data)
          })
        })
        return
      }

      let readOnly = false
      if (this.gridApi) {
        const selectedRow = this.gridApi.getFocusedCell()
        if (selectedRow) {
          const row = this.gridApi.rowModel.getRow(selectedRow.rowIndex)
          readOnly = row.data.statuspdr !== '0'
        }
      }
      this.copReadOnly = readOnly

      this.$nextTick(() => {
        this.showCopOf = true
        this.$nextTick(() => {
          this.$refs.cop.show(params.node.data)
        })
      })
    },
    printAllCOP (params) {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = []

      ranges.forEach(rg => {
        for (let i = rg.startRow.rowIndex; i <= rg.endRow.rowIndex; i++) {
          const rowData = this.pciDataGridOptions.api.rowModel.getRow(i).data
          data.push(rowData)
        }
      })

      this.$bvModal.msgBoxConfirm(this.$lang.PCI.COP.PrintOfficialConfirmation, {
        title: this.$lang.PCI.COP.PrintOfficialTitle,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then(confirmed => {
          if (confirmed) {
            const requestQueryParams = new URLSearchParams()
            data.map(row => requestQueryParams.append('obraID', row.obraId))

            const request = {
              params: requestQueryParams
            }

            loading.push()
            COPOficialWorkModelRepository.PrintAllCop(request)
              .then(response => {
                if (response.data.code > 0) {
                  const binary = window.atob(response.data.data.replace(/\s/g, ''))
                  const len = binary.length
                  const buffer = new ArrayBuffer(len)
                  const view = new Uint8Array(buffer)
                  for (let i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i)
                  }
                  const blob = new Blob([view], {type: 'application/pdf'})

                  const fileURL = URL.createObjectURL(blob)
                  window.open(fileURL)
                }
              })
              .finally(() => loading.close())
          }
        })
    },
    viewTecAnalysis () {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = []
      ranges.forEach(rg => {
        for (let i = rg.startRow.rowIndex; i <= rg.endRow.rowIndex; i++) {
          const rowData = this.pciDataGridOptions.api.rowModel.getRow(i).data
          if (!data.includes(rowData)) {
            data.push(rowData)
          }
        }
      })
      this.showTecAnalysis = true
      this.$nextTick(() => {
        this.$refs['tecAnalysis'].show(data)
      })
    },
    onOpenQuotes (contract) {
      const data = [this.rowData.filter(r => r.referenciaContrato === contract)[0]]
      this.showQuotes = false
      this.showTecAnalysis = true
      this.$nextTick(() => {
        this.$refs['tecAnalysis'].show(data, tecAnalysisTypes.Quote)
      })
    },
    viewTecAnalysisQuote () {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = [this.pciDataGridOptions.api.rowModel.getRow(ranges[0].startRow.rowIndex).data]
      this.showTecAnalysis = true
      this.$nextTick(() => {
        this.$refs['tecAnalysis'].show(data, tecAnalysisTypes.Quote)
      })
    },
    viewTecAnalysisNa (params) {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = []
      ranges.forEach(rg => {
        for (let i = rg.startRow.rowIndex; i <= rg.endRow.rowIndex; i++) {
          const rowData = this.pciDataGridOptions.api.rowModel.getRow(i).data
          if (!data.includes(rowData)) {
            data.push(rowData)
          }
        }
      })

      this.showTecAnalysisNa = true
      this.$nextTick(() => {
        this.$refs['tecAnalysisNa'].show(data)
      })
    },
    viewPO (params) {
      this.showPo = true
      this.$nextTick(() => {
        this.$refs['po'].show(params.node.data.obraId)
      })
    },
    viewBills (params) {
      this.showBills = true
      this.$nextTick(() => {
        this.$refs['bills'].show(params.node.data.obraId)
      })
    },
    viewPurchaseOrder (params) {
      this.showPurchaseOrder = true
      this.$nextTick(() => {
        this.$refs['purchaseorder'].show(params.node.data)
      })
    },
    viewStoppage (params) {
      this.showStoppage = true
      this.$nextTick(() => {
        this.$refs['stoppage'].show(params.node.data)
      })
    },
    setChangeAll (params, value) {
      var list = []

      this.gridApi.getCellRanges().forEach((range) => {
        range.columns.forEach(col => {
          if (col.colId === params.column.colId) {
            for (let i = range.startRow.rowIndex; i <= range.endRow.rowIndex; i++) {
              const rowNode = params.api.getDisplayedRowAtIndex(i)
              if ((rowNode.data[params.column.colId] || false).toString().toLowerCase() !== value.toString().toLowerCase()) {
                list.push(
                  {
                    pciObra: rowNode.data.obraId,
                    obraCandidato: rowNode.data.obraCandidatoId,
                    field: params.column.colId,
                    valor: value
                  }
                )
              }
            }
          }
        })
      })
      if (list.length === 0) {
        return
      }

      this.$bvModal.msgBoxConfirm(this.$lang.Common.LabelConfirmation, {
        title: this.$lang.PCI.ChangeAllConfirmation.replace('#lines#', list.length),
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then(confirmed => {
          if (confirmed) {
            loading.push()

            list.forEach(l => {
              const rowNode = params.api.getRowNode(l.pciObra + l.obraCandidato)
              if (rowNode) {
                rowNode.setDataValue(params.column.colId, value, 'blockEdit')
              } else {
                console.log('eita')
              }
            })

            let status = 0
            WorkPCIRepository.UpdateFieldList(list)
              .then(response => {
                status = response.status
                if (response.status !== 200) {
                  toast.warning(response.data.message)
                }
              })
              .catch(() => {
                toast.error(this.$lang.Common.CouldNotSave)
              })
              .finally(() => {
                loading.close()
              })
              .then(() => {
                if (status === 200) {
                  this.loadGridRowValues()
                }
              })
          }
        })
    },
    downloadLegalReport () {
      const rowIndex = this.pciDataGridOptions.api.getCellRanges()[0].startRow.rowIndex
      const rowNode = this.pciDataGridOptions.api.rowModel.getRow(rowIndex)
      loading.push()
      if (document.querySelector('title').text.includes('JURÍDICO')) {
        const repository = WorkPCIRepository.DownloadLegalReport(rowNode.data.obraId)
        repository
          .then(response => {
            if (response.data.code > 0) {
              const layout = Buffer.from(response.data.data.file, 'base64')
              const blob = new Blob([layout], { type: response.data.data.contentType + ';charset=utf-8;' })
              try {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = response.data.data.name
                link.click()
                URL.revokeObjectURL(link.href)
              } catch (error) {
                console.log(error)
              }
            }
          })
          .finally(() => loading.close())
      } else {
        const repository = WorkPCIRepository.DownloadLegalContractReport(rowNode.data.obraId)
        repository
          .then(response => {
            if (response.data.code > 0) {
              try {
                this.dataReport = response.data.data
                this.openReport = true
              } catch (error) {
                console.log(error)
              }
            }
          })
          .finally(() => loading.close())
      }
    },
    getCancellableRows () {
      const ranges = this.pciDataGridOptions.api.getCellRanges()
      const data = []
      ranges.forEach(rg => {
        for (let i = rg.startRow.rowIndex; i <= rg.endRow.rowIndex; i++) {
          data.push(this.pciDataGridOptions.api.rowModel.getRow(i).data)
        }
      })
      return data.filter(d => !(d && d.terminoObraParalisacao))
    },
    viewCancellation () {
      this.showCancellation = true
      this.$nextTick(() => {
        this.$refs['cancellation'].show(this.getCancellableRows())
      })
    },
    // Update item visibility when the user change its in tree view
    updateItemVisibility (item) {
      this.columnApi.setColumnVisible(item.field, item.checked)
    },
    onEdit (event) {
      if (event.source === 'blockEdit') {
        return
      }

      if (event.data.arquivadoFinanc.toLowerCase() === 'true' && event.colDef.ItemFinanc) {
        toast.error(this.$lang.PCI.Mounting.AlertArchivedFinance)
        // Rollback field value
        event.node.data[event.colDef.field] = event.oldValue
        event.api.refreshCells()
        return
      }

      if (event.data.arquivado.toLowerCase() === 'true' && !event.colDef.ItemFinanc) {
        toast.error(this.$lang.PCI.Mounting.AlertArchivedWorks)
        // Rollback field value
        event.node.data[event.colDef.field] = event.oldValue
        event.api.refreshCells()
        return
      }

      this.loadingAlerts = true
      window.work2Update[event.data.id + event.data.obraCandidatoId + event.colDef.field] = {
        timestamp: new Date().getTime(),
        event: event
      }
    },
    processUpdate () {
      if (!window.isProcessingUpdate) {
        window.isProcessingUpdate = true
        const promises = [Promise.resolve()]
        if (Object.entries(window.work2Update).length) {
          let maxTimestamp = 0
          const currentTimestamp = new Date().getTime()
          const entries = Object.entries(window.work2Update)
          // eslint-disable-next-line no-unused-vars
          for (const [key, value] of entries) {
            maxTimestamp = value.timestamp > maxTimestamp ? value.timestamp : maxTimestamp
          }
          if ((currentTimestamp - maxTimestamp) > 200) {
            for (const [key, value] of entries) {
              const event = value.event

              // Stores cell field, new value
              let field = event.colDef.field
              let newValue = event.newValue ? event.newValue : event.newValue !== false ? '' : false
              let obraId = event.data.id
              let candId = event.data.obraCandidatoId
              const obj = {
                pciObra: obraId,
                obraCandidato: candId,
                field,
                valor: newValue
              }
              delete window.work2Update[key]
              promises.push(
                WorkPCIRepository.UpdateField(obj)
                  .then(response => {
                    // Verifies response status
                    if (response.data.code === 204 && response.data.message === 'RETRY') {
                      this.onEdit(event)
                    } else if (response.data.code !== 200 && !response.data.message.startsWith('@@')) {
                      // Set a warning toast
                      toast.warning(response.data.message)
                      // Rollback field value
                      event.node.data[event.colDef.field] = event.oldValue
                      event.api.refreshCells()
                    } else if (response.data.code < 0 && response.data.message.startsWith('@@')) {
                      if (response.data.message === '@@ARQUIV1') toast.error(this.$lang.PCI.Mounting.AlertArchivedWorks)
                      if (response.data.message === '@@ARQUIV2') toast.error(this.$lang.PCI.Mounting.AlertArchivedFinance)
                      event.node.data[event.colDef.field] = event.oldValue
                      event.api.refreshCells()
                    } else {
                      const countRow = [...this.pciCountRowData]
                      let value = 0
                      if ((event.newValue && event.newValue !== '#NA#') && (!event.oldValue || event.oldValue === '#NA#')) {
                        value = 1
                      }
                      if ((!event.newValue || event.newValue === '#NA#') && (event.oldValue && event.oldValue !== '#NA#')) {
                        value = -1
                      }
                      countRow[0][event.colDef.field] += value

                      this.pciCountRowData = countRow

                      const fields = window.work2Automatization[event.data.id] ? window.work2Automatization[event.data.id].fields : []
                      fields.push(event.colDef.field)
                      window.work2Automatization[event.data.id] = {
                        timestamp: new Date().getTime(),
                        node: event.node,
                        fields: fields
                      }
                    }
                  })
                  .catch(() => {
                    // Set a error toast
                    toast.error(this.$lang.Common.CouldNotSave)

                    // Rollback field value
                    event.node.data[event.colDef.field] = event.oldValue
                    event.api.refreshCells()
                  })
              )

              Promise.all(promises)
                .finally(() => {
                  window.isProcessingUpdate = false
                  this.loadingAlerts = false
                  this.calculateTotals()
                })
            }
          }
        } else {
          window.isProcessingUpdate = false
        }
      } else {
        window.isProcessingUpdate = false
      }
      setTimeout(() => {
        this.processUpdate()
      }, 200)
    },
    processAutomatization () {
      if (!window.isProcessingUpdate && !window.isProcessingAutomatization) {
        window.isProcessingAutomatization = true
        let promises = [Promise.resolve()]
        if (Object.entries(window.work2Automatization).length) {
          let maxTimestamp = 0
          const entries = Object.entries(window.work2Automatization)
          // eslint-disable-next-line no-unused-vars
          for (const [key, value] of entries) {
            maxTimestamp = value.timestamp > maxTimestamp ? value.timestamp : maxTimestamp
          }
          const currentTimestamp = new Date().getTime()
          if ((currentTimestamp - maxTimestamp) > 1000) {
            for (const [key, value] of entries) {
              if (!window.work2Update[key]) {
                const item = value.node.data.item
                delete window.work2Automatization[key]
                promises.push(
                  WorkPCIRepository.Automatization(value.node.data.obraId)
                    .finally(() => {
                      if (!window.work2Automatization[value.node.data.obraId]) {
                        PCIRepository.GetPCIWork(value.node.data.obraId)
                          .then(response => {
                            if (response.data.code > 0) {
                              let data = response.data.data[0].Data.filter(d => d.obraCandidatoId === value.node.data.obraCandidatoId)
                              data[0].item = item
                              const row = this.gridApi.getRowNode(data[0].id + data[0].obraCandidatoId)
                              // eslint-disable-next-line no-unused-vars
                              for (const [key2, value2] of Object.entries(data[0])) {
                                if (key2 !== 'id' && !value.fields.some(f => f === key2)) {
                                  if (this.gridApi.getColumnDef(key2)) {
                                    row.setDataValue(key2, data[0][key2], 'blockEdit')
                                  } else {
                                    row.data[key2] = data[0][key2]
                                  }
                                }
                              }
                            }
                          }).catch(err => console.log(err))
                      }
                    })
                    .catch(err => console.log(err))
                )
              }
            }
            Promise.all(promises)
              .then(() => {
                PCIRepository.GetAlerts(this.pciId)
                  .then(response => {
                    if (response.data.code > 0) {
                      this.alerts = this.alertasDoFiltro(response.data.data)
                      this.onFilterAlertRows(this.alertFilter)
                      this.$nextTick(() => {
                        this.gridApi.refreshCells({force: true})
                      })
                    }
                    window.isProcessingAutomatization = false
                  })
                  .catch(err => console.log(err))
              })
              .catch(err => console.log(err))
              .finally(() => this.calculateTotals())
          } else window.isProcessingAutomatization = false
        } else window.isProcessingAutomatization = false
      }
      setTimeout(() => {
        this.processAutomatization()
      }, 200)
    },
    toggleNA () {
      const ranges = this.gridApi.getCellRanges()
      ranges.forEach(r => {
        for (var i = r.startRow.rowIndex; i <= r.endRow.rowIndex; i++) {
          const row = this.gridApi.rowModel.getRow(i)
          const dt = row.data
          r.columns.forEach(c => {
            const isEditable = c.colDef.editable
            if (isEditable) {
              const fld = c.colDef.field
              const na = dt[fld]
              if (na === '#NA#') {
                this.unsetNA({node: row, column: c})
              } else {
                this.setNA({node: row, column: c})
              }
            }
          })
        }
      })
    },
    isRangeExtended () {
      const range = this.gridApi.getCellRanges()
      let rows = 0
      let cols = 0
      range.forEach(r => {
        rows += r.endRow.rowIndex - r.startRow.rowIndex + 1
        cols += r.columns.length
      })

      const cels = rows * cols
      return cels > 1
    },
    restoreFocus () {
      this.$nextTick(() => {
        const range = this.gridApi.getCellRanges()[0]
        this.gridApi.setFocusedCell(range.startRow.rowIndex, range.startColumn)
      })
    },
    searchMecanism (event) { // usando referencias de https://www.toptal.com/developers/keycode
      // Backspace
      if (event.keyCode === 8) {
        this.advSearch.lastSearchedWord = this.advSearch.lastSearchedWord.substring(0, this.advSearch.lastSearchedWord.length - 1)
      }

      if (
        (event.keyCode >= 48 && event.keyCode <= 90) || // 0-9 e A-Z
        (event.keyCode >= 96 && event.keyCode <= 111) || // Numpad
        (event.keyCode >= 160 && event.keyCode <= 165) || // Especiais
        (event.keyCode >= 169 && event.keyCode <= 173) || // Especiais
        (event.keyCode >= 186 && event.keyCode <= 223) || // Especiais
        (event.keyCode === 226) ||// Especiais
        (event.keyCode === 32) ||// Especiais
        (event.keyCode === 8) // Backspace
      ) {
        if (event.keyCode !== 8) this.advSearch.lastSearchedWord += event.key
        this.gridChangeSearchData()
      } else {
        if (this.advSearch.lastSearchedWord) {
          this.advSearch.lastSearchedWord = ''
          this.gridApi.refreshCells({force: true})
        }
      }
    },
    gridChangeSearchData () {
      this.advSearch.originalData = cloneDeep(this.gridApi.rowModel.rowsToDisplay.map(r => r.data))
      let rowData = this.advSearch.originalData

      let advSearch = this.advSearch
      let goToLine = true
      let lineToGo = 0
      let exist = false
      let changed = false
      let searchWord = advSearch.lastSearchedWord.toUpperCase()

      if (searchWord) {
        rowData.some((x, i) => {
          let currentValue = x[advSearch.lastClickedColumn.colId]
          changed = false

          if (currentValue.startsWith(searchWord)) {
            changed = true
            exist = true
          }

          if (goToLine && changed) {
            lineToGo = i
            goToLine = false
            return true
          }
          return false
        })
      }

      if (changed) {
        this.gridApi.refreshCells({force: true})
      }
      if (exist === false) {
        this.advSearch.lastSearchedWord = this.advSearch.lastSearchedWord.substring(0, this.advSearch.lastSearchedWord.length - 1)
      } else if (lineToGo) {
        this.setSelectedRow(lineToGo)
      }
    },
    setSelectedRow: debounce(function (rowIndex) {
      this.gridApi.ensureIndexVisible(rowIndex, 'middle')
      this.gridApi.setFocusedCell(rowIndex, this.advSearch.lastClickedColumn.colId)
    }, 200)
  },
  mounted () {
    const grid = document.getElementById('gridPci')

    const contains = (elements, event) => {
      const arr = Array.from(elements)
      let elFound = false
      arr.forEach(a => {
        // if (a === event.target) elFound = true
        // if (!elFound && a.children.length) elFound = contains(a.children, event)
        const rect = a.getBoundingClientRect()
        elFound = elFound || (event.x >= rect.x && event.x <= rect.x + rect.width && event.y >= rect.y && event.y <= rect.y + rect.height)
      })
      return elFound
    }

    grid.addEventListener('click', event => {
      const el = document.getElementById('alerts-container')
      if (this.showAlerts && el && !contains(el, event)) this.showAlerts = false
      const el2 = document.getElementById('quotes-container')
      if (this.showQuotes && el2 && !contains(el2, event)) this.showQuotes = false
      const tp = document.getElementsByClassName('ag-side-bar')
      if (tp && !contains(tp, event)) this.gridApi.closeToolPanel()
    })
    // Add shortcuts
    grid.addEventListener('keydown', async event => {
      if ((event.key === 'v' || event.key === 'V') && event.ctrlKey &&
        this.pciDataGridOptions.api.getEditingCells() &&
        this.pciDataGridOptions.api.getEditingCells().length === 0 &&
        this.pciDataGridOptions.api.getFocusedCell() &&
        this.pciDataGridOptions.api.getFocusedCell().column &&
        this.pciDataGridOptions.api.getFocusedCell().column.colDef.type === 'memoColumn' &&
          this.pciDataGridOptions.api.getFocusedCell().column.colDef.editable) {
        this.shiftKey = event.shiftKey
        /*
        event.stopPropagation()
        event.preventDefault()
        */
      }

      if (this.pciDataGridOptions.api && this.pciDataGridOptions.api.getCellRanges() && this.pciDataGridOptions.api.getCellRanges().length) {
        const rowIndex = this.pciDataGridOptions.api.getCellRanges()[0].startRow.rowIndex
        const rowNode = this.pciDataGridOptions.api.rowModel.getRow(rowIndex)
        const data = this.gridApi.rowModel.getRow(rowIndex).data

        if (event.key === 'F9' &&
            (this.hasRole(this.roles.RW_OPER_PCI_AT_REGIONAL) ||
             this.hasRole(this.roles.RW_OPER_PCI_AT_PLAN) ||
             this.hasRole(this.roles.RW_OPER_PCI_AT_BUDGET) ||
             this.hasRole(this.roles.RW_OPER_PCI_AT_FINANC))
        ) {
          event.preventDefault()
          event.stopPropagation()
          this.viewTecAnalysis()
        }
        if (event.key === 'F3' && this.hasRole(this.roles.RW_OPER_PCI_PURCHASE)) {
          event.preventDefault()
          event.stopPropagation()
          this.viewPO({node: rowNode})
        }
        if (event.key === 'F2' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION_APPROVE)) {
          event.preventDefault()
          event.stopPropagation()
          if (data.libavaliacaopdr && !data.autorizacaopdr && !data.rejeicaopdr) {
            this.authorizePDR({node: rowNode})
          }
        }
        if (event.key === 'F4' && this.hasRole(this.roles.RW_OPER_PCI_BILLS)) {
          event.preventDefault()
          event.stopPropagation()
          this.viewBills({node: rowNode})
        }
        if (event.key === 'F5' && this.hasRole(this.roles.RW_OPER_PCI_PURCHASE)) {
          event.preventDefault()
          event.stopPropagation()
          this.viewPurchaseOrder({node: rowNode})
        }
        if (event.key === 'F6') {
          event.preventDefault()
          event.stopPropagation()
          this.viewCOPof({node: rowNode})
        }
        if (event.key === 'F7' && this.hasRole(this.roles.RW_OPER_PCI_WORK)) {
          event.preventDefault()
          event.stopPropagation()
          this.viewAddress({node: rowNode})
        }
        if (event.key === 'F8') {
          event.preventDefault()
          event.stopPropagation()
          this.viewTeam()
        }
        if (event.key === 'F10') {
          event.preventDefault()
          event.stopPropagation()
          this.selectZdocsFolder(rowNode.data.obraId)
        }
        if (event.key === 'F11') {
          event.preventDefault()
          event.stopPropagation()
          this.showZdocsFolder({obraId: rowNode.data.obraId, gedPastaId: rowNode.data.gedPastaId})
        }
      }
    })
    grid.addEventListener('keyup', async event => {
      if (event.key === 'Escape' && this.showAlerts) this.showAlerts = false
      if (event.key === 'Escape' && this.showQuotes) this.showQuotes = false

      if (this.pciDataGridOptions.api.getCellRanges() && this.pciDataGridOptions.api.getCellRanges().length) {
        const rowIndex = this.pciDataGridOptions.api.getCellRanges()[0].startRow.rowIndex
        const rowNode = this.pciDataGridOptions.api.rowModel.getRow(rowIndex)
        const data = this.pciDataGridOptions.api.rowModel.getRow(rowIndex).data
        const colId = this.pciDataGridOptions.api.getCellRanges()[0].startColumn.colId

        // Busca limitada a Cód. Obra e Id Site

        if (colId === 'idSite' || colId === 'referencia') {
          if (event.key === 'Escape') {
            this.advSearch.lastSearchedWord = ''
            this.gridApi.refeshCells({force: true})
            return
          }

          if (this.advSearch.lastClickedColumn !== this.pciDataGridOptions.api.getCellRanges()[0].startColumn) {
            this.advSearch.lastSearchedWord = ''
            this.advSearch.lastClickedColumn = this.pciDataGridOptions.api.getCellRanges()[0].startColumn
          }

          if (!event.ctrlKey && !event.altKey) {
            this.searchMecanism(event)
          }
        }

        if (event.ctrlKey && event.altKey) {
          if (event.key === 'n' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION)) {
            event.preventDefault()
            event.stopPropagation()

            const ranges = this.pciDataGridOptions.api.getCellRanges()
            if (ranges && ranges.length) {
              this.toggleNA()
            }
          }
          if (event.key === 'l' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION)) {
            event.preventDefault()
            event.stopPropagation()
            if ((data.rejeicaopdr || !data.libavaliacaopdr) && data.terminoReal) {
              this.createPDR({node: this.pciDataGridOptions.api.getSelectedNodes()[0]})
            }
          }
          if (event.key === 'r' && this.hasRole(this.roles.RW_OPER_PCI_EVALUATION_APPROVE)) {
            event.preventDefault()
            event.stopPropagation()
            if (data.libavaliacaopdr && !data.autorizacaopdr && !data.rejeicaopdr) {
              this.rejectPDR({node: this.pciDataGridOptions.api.getSelectedNodes()[0]})
            }
          }
          if (event.key === 'h') {
            event.preventDefault()
            event.stopPropagation()
            const column = this.pciDataGridOptions.api.getCellRanges()[0].columns[0]
            this.viewPciItemLog({node: rowNode, column: column})
          }
        }
      }
    })

    // const element = document.getElementsByClassName('ag-body')[0]
    // element.addEventListener('paste', async (e) => {
    grid.addEventListener('paste', async (e) => {
      if (e.target instanceof HTMLElement) {
        if (this.gridApi.getEditingCells() &&
          this.gridApi.getEditingCells().length === 0 &&
          this.gridApi.getFocusedCell() &&
          this.gridApi.getFocusedCell().column &&
          this.gridApi.getFocusedCell().column.colDef.type === 'memoColumn' &&
          this.pciDataGridOptions.api.getFocusedCell().column.colDef.editable) {
          e.preventDefault()
          e.stopPropagation()

          let splited = []
          const dataFull = e.clipboardData.getData('text')
          if (this.shiftKey) {
            const regex = /"([^"]*)"|([^"\n\r]+)/gm
            let match
            while ((match = regex.exec(dataFull)) !== null) {
              const valor = match[1] || match[2]
              splited.push(valor.trim())
            }
          } else {
            splited = dataFull.split('"\r\n')
              .map((item) => {
                var itPure = item.replace(/^"/g, '').replace(/"\r/g, '')
                return itPure
              }).filter((item) => { return !!item })
          }
          if (splited[splited.length - 1] === '\n') {
            splited.splice(splited.length - 1, 1)
          }

          const cellRanges = this.gridApi.getCellRanges()
          const normalizeGreater = cellRanges[0].startRow.rowIndex > cellRanges[0].endRow.rowIndex ? cellRanges[0].startRow.rowIndex : cellRanges[0].endRow.rowIndex
          const normalizeLesser = cellRanges[0].startRow.rowIndex < cellRanges[0].endRow.rowIndex ? cellRanges[0].startRow.rowIndex : cellRanges[0].endRow.rowIndex
          const rowQtd = normalizeGreater - normalizeLesser + 1

          if (splited.length >= rowQtd) {
            for (var i = 0; i < splited.length; i++) {
              const field = cellRanges[0].columns[0].colDef.field.toString()
              this.gridApi.rowModel.getRow(cellRanges[0].startRow.rowIndex + i).setDataValue(field, splited[i])
            }
          } else {
            var controlIndex = 0
            for (var y = normalizeLesser; y <= normalizeGreater; y++) {
              if (controlIndex >= splited.length) controlIndex = 0

              const field = cellRanges[0].columns[0].colDef.field.toString()
              this.gridApi.rowModel.getRow(y).setDataValue(field, splited[controlIndex])
              controlIndex++
            }
          }
        }
      }
    })

    window.work2Automatization = {}
    this.processAutomatization()
    window.work2Update = {}
    this.processUpdate()
  },
  beforeMount () {
    this.updatingLayout = true

    this.gridApi = this.pciDataGridOptions.api
    this.columnApi = this.pciDataGridOptions.columnApi

    this.pciDataGridOptions.alignedGrids.push(this.pciCountGridOptions)
    this.pciCountGridOptions.alignedGrids.push(this.pciDataGridOptions)

    if (!this.$route.query.paramId) return

    const paramId = this.$route.query.paramId
    this.pciAllColumns = this.$route.query.pciAllColumns
    this.obraIdFiltro = this.$route.query.obraId || null
    this.obraRefFiltro = this.$route.query.obraRef || ''
    if (window.localStorage.getItem(paramId)) {
      const pciIdStr = window.localStorage.getItem(paramId)
      window.localStorage.removeItem(paramId)
      window.sessionStorage.setItem(paramId, pciIdStr)
    }

    const pciIdStr = window.sessionStorage.getItem(paramId)
    if (!pciIdStr) return

    let pciId = JSON.parse(pciIdStr)

    this.pciId = pciId

    this.onLoadGridValues(true)
    // .catch(error => {
    //   console.log(error)
    //   toast.error(this.$lang.Common.Alerts.Error)
    // })
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pci.js